import { styled } from '@mui/material/styles';
import {
  Button,
  Box,
  ListItemButton,
  Typography,
  Popover,
} from '@mui/material';

export const DropdownButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  padding: '6px 16px',
  color: theme.palette.text.primary,
  borderColor: theme.palette.divider,
  borderRadius: '6px',
  fontWeight: 500,
  fontSize: '14px',
  backgroundColor: '#fff',
  height: '36px',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    borderColor: theme.palette.divider,
  },
}));

export const DropdownIcon = styled('i')({
  marginLeft: '8px',
  fontSize: '16px',
});

export const SelectorContainer = styled(Box)({
  display: 'flex',
  minWidth: '450px',
  padding: '8px 0',
});

export const PresetsContainer = styled(Box)({
  width: '180px',
  display: 'flex',
  flexDirection: 'column',
});

export const CustomRangeContainer = styled(Box)({
  flex: 1,
  padding: '16px',
});

export const PresetItem = styled(ListItemButton)<{ selected?: boolean }>(
  ({ theme, selected }) => ({
    padding: '8px 16px',
    backgroundColor: selected ? theme.palette.action.selected : 'transparent',
    borderLeft: `3px solid ${
      selected ? theme.palette.primary.main : 'transparent'
    }`,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  })
);

export const ApplyButton = styled(Button)(({ theme }) => ({
  marginTop: 'auto',
  textTransform: 'none',
  borderRadius: '6px',
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none',
  },
}));

export const StyledPopover = styled(Popover)(({ theme }) => ({
  '& .MuiPopover-paper': {
    borderRadius: '12px',
    marginTop: '8px',
    boxShadow: theme.shadows[4],
  },
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontWeight: 600,
  fontSize: '0.875rem',
}));

export const PresetsTitle = styled(SectionTitle)({
  padding: '8px 16px',
});

export const CustomRangeTitle = styled(SectionTitle)({
  marginBottom: '16px',
});

export const DatesFlexContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
});

export const ErrorMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: '12px',
  marginTop: '4px',
  fontWeight: 500,
  textAlign: 'center',
}));
